// Canonical cache keys for the Slot Availability Calendar's range-scoped
// reads (one visible month/day at a time — see the plan doc's data-flow
// table in section 3.4). Pulled out of SlotCalendarDb.ts / SlotCalendarThunks.ts
// so both can build the identical key without importing each other.

import { SlotSummaryBucket } from "../../interfaces/SlotCalendarObject";

export function buildAvailabilityRangeKey(params: { fromIso: string; toIsoExclusive: string }): string {
  return `${params.fromIso}|${params.toIsoExclusive}`;
}

export function buildSummaryRangeKey(params: {
  bucket: SlotSummaryBucket;
  fromDate: string;
  toDateExclusive: string;
}): string {
  return `${params.bucket}|${params.fromDate}|${params.toDateExclusive}`;
}
